import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { loaderStart, loaderStop } from "../features/HomeMaster"

export const TradeMarket2 = () => {
    const [datam, setdata] = useState([])
    const [resultPop, setResultPop] = useState()
    const loader = useSelector(state => state.homeMaster?.loader)
    const dispatch = useDispatch()

    const fetchTradeDetails = async () => {
        const data = await fetch('https://magicapi.4magics.com/api/v1/admin/gettrademarketsall')
        let resData = await data.json()
        let setss = []
        for (let i = 0; i < resData.data.length; i++) {
            const element = resData.data[i];
            let isexist = setss.find(a => a.eventName === element.eventName)
            if (isexist) {
                isexist.data.push(element)
            } else {
                setss.push({
                    eventName: element.eventName,
                    data: [element]
                })
            }
        }
        setdata(setss)
    }
    const [resultData, setResultData] = useState({
        winerId: "",
    })

    const openResultPop = (data) => {
        setResultPop(data)
    }

    const giveResultToPOSTGFANCY = async (mid, wid) => {
        const bodyData =
        {
            "mid": mid,
            "sid": wid,
        }
        const res2 = await fetch('https://magicapi.4magics.com/api/v1/result/postresultfancy', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(bodyData)
        })
        const data2 = await res2.json()
        const res22 = await fetch('https://masterpg.9xxbet.com/api/v1/result/postresultnormal', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(bodyData)
        })
        const data22 = await res22.json()
        if (data2.status === 'success') {
            toast.success("result updated to postgrey")
        }
    }
    const giveResultToPOSTGNORMAL = async (mid, wid) => {
        const bodyData =
        {
            "mid": mid,
            "sid": wid,
        }
        const res2 = await fetch('https://magicapi.4magics.com/api/v1/result/postresultnormal', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(bodyData)
        })
        const data2 = await res2.json()
        const res22 = await fetch('https://masterpg.9xxbet.com/api/v1/result/postresultnormal', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(bodyData)
        })
        const data22 = await res22.json()
        if (data2.status === 'success') {
            toast.success("result updated to postgrey")
        }
    }
    const dateFormater = (date, separator, day) => {
        var day = date.getDate()
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        return year + separator + month + separator + day;
    }
    const timeFormate = (date) => {
        var day = date.getHours()
        var month = date.getMinutes();
        var year = date.getSeconds();
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        return day + ":" + month + ":" + year;
    }
    const addFancyPrice = async (element) => {
        const mainObj = {
            pkHeader: {
                shMessageCode: 0
            },
            stMarketID: element.stMarketID,
            stSelectionID: "Score",
            stInstrumentID: element.stMarketID + "_Score",
            Back: [
                {
                    Price: element.b1,
                    Size: element.bs
                },
                {
                    "Price": 0.0,
                    "Size": 0.0
                },
                {
                    "Price": 0.0,
                    "Size": 0.0
                }
            ],
            Lay: [
                {
                    "Price": element.l1,
                    "Size": element.ls
                },
                {
                    "Price": 0.0,
                    "Size": 0.0
                },
                {
                    "Price": 0.0,
                    "Size": 0.0
                }
            ],
            dbLTP: 0.0,
            dbMatched: 0.0,
            btMarketStatus: element.status,
            stType: 0,
            rBack: null,
            rLay: null,
            gameStage: 0,
            dtLastUpdated: dateFormater(new Date(), "-") + " " + timeFormate(new Date())
        }
        const raw = JSON.stringify(mainObj);
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://masterapi.fun4club.com/api/Admin/postBrodcast", requestOptions)
            .then(response => response.json())
            .then(result => {

            })
            .catch(error => {
                toast.error("Server Error 500")
                console.log('error', error)
            });
    }
    const onResultSelectChange = (e) => {
        setResultData({ ...resultData, winerId: e.target.value })
    }
    const saveResult = async (mid, wid, name) => {
        if (window.confirm("Please confirm winner that is " + wid + " for " + name)) {
            if (window.confirm("Please confirm again your winner id = " + wid + " and runner = " + name)) {
                // giveResultToMongo(mid, wid)
                // giveResultToVelki(mid, wid)
                giveResultToPOSTGFANCY(mid, wid)
                // giveResultToShree(mid, wid)
                // giveResultToFox(mid, wid)
                // giveResultToMaster(mid, wid)
                // giveResultToParker(mid, wid)
                // giveResultTo39(mid, wid)
                addFancyPrice({ stMarketID: mid, b1: 0, bs: 0, l1: 0, ls: 0, status: 3 })
                return
            }
        }
        return
    }
    const saveResultToNormal = async (mid, wid, name) => {
        if (window.confirm("Please confirm winner that is " + wid + " for " + name)) {
            if (window.confirm("Please confirm again your winner id = " + wid + " and runner = " + name)) {
                // giveResultToMongo(mid, wid)
                // giveResultToVelki(mid, wid)
                giveResultToPOSTGNORMAL(mid, wid)
                // giveResultToShree(mid, wid)
                // giveResultToFox(mid, wid)
                // giveResultToMaster(mid, wid)
                // giveResultToParker(mid, wid)
                // giveResultTo39(mid, wid)
                // addFancyPrice({ stMarketID: mid, b1: 0, bs: 0, l1: 0, ls: 0, status: 3 })
                return
            }
        }
        return
    }

    const onResultDChange = (e) => {
        setResultData({ ...resultData, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        fetchTradeDetails()
        let a = setInterval(() => {
            fetchTradeDetails()
        }, 50000);
        return () => {
            clearInterval(a)
        }
    }, [])

    return (
        <div className='container-fluid page-body-wrapper overflow-auto'>
            <div className="main-panel overflow-auto">
                <div className="content-wrapper overflow-auto">
                    <div style={{ marginTop: "110px" }} className="row overflow-auto">
                        <div className="col-md-12 overflow-auto">
                            <table class="table table-striped table-bordered overflow-auto">
                                <thead className="table-dark">
                                    <th>MarketName <button onClick={() => fetchTradeDetails()}>
                                        Refresh
                                    </button> </th>
                                    <th>EventName</th>
                                    <th>Result</th>
                                </thead>
                                <tbody>
                                    {
                                        datam?.map(d => (
                                            d.data.map(a => (
                                                <tr>
                                                    <td>{a.marketName}</td>
                                                    <td>{a.eventName}</td>
                                                    <td>{a.eventTypeName}</td>
                                                    <td>{new Date(a.marketTime).toLocaleString()}</td>
                                                    <td>
                                                        <button data-bs-toggle="modal" data-bs-target="#result-popup" onClick={() => {
                                                            setResultData({
                                                                winerId: ""
                                                            })
                                                            openResultPop(a)
                                                        }} _ngcontent-mck-c63="" className="btn btn-primary text-white" fdprocessedid="2870zc">
                                                            Close
                                                        </button>
                                                        <button data-bs-toggle="modal" data-bs-target="#delete-popup" onClick={() => {
                                                            setResultData({
                                                                winerId: ""
                                                            })
                                                            openResultPop(a)
                                                        }} _ngcontent-mck-c63="" className="btn btn-danger text-white" fdprocessedid="2870zc">
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div _ngcontent-tpi-c33="" id="delete-popup" tabindex="-1" aria-labelledby="delete-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div _ngcontent-tpi-c33="" class="modal-dialog">
                    <div _ngcontent-tpi-c33="" class="modal-content">
                        {
                            loader ? (
                                <div>Loading...</div>
                            ) : (
                                <>
                                    <div _ngcontent-tpi-c33="" class="modal-header text-dark">
                                        <h1 _ngcontent-tpi-c33="" id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">{resultPop && resultPop.stMarketName || resultPop?.marketName}</h1>
                                        <button _ngcontent-tpi-c33="" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                                    </div>
                                    <div _ngcontent-tpi-c33="" class="modal-body">
                                        <div className=''>Do you want to delete this market?</div>
                                        <button onClick={() => {
                                            dispatch(loaderStart())
                                            saveResult(resultPop.stMarketID || resultPop.marketId, "Delete", resultPop.stMarketName || resultPop?.marketName).then((data) => {
                                                if (data?.success) {
                                                    toast.success("Result has been uploaded successfully")
                                                } else {
                                                    toast.error("Server error")
                                                }
                                                dispatch(loaderStop())
                                            })
                                        }} className='btn btn-danger'>Delete</button>
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
            </div>
            <div _ngcontent-tpi-c33="" id="result-popup" tabindex="-1" aria-labelledby="result-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div _ngcontent-tpi-c33="" class="modal-dialog">
                    <div _ngcontent-tpi-c33="" class="modal-content">
                        {
                            loader ? (
                                <div>Loading...</div>
                            ) : (
                                <>
                                    <div _ngcontent-tpi-c33="" class="modal-header text-dark">
                                        <h1 _ngcontent-tpi-c33="" id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">{resultPop && resultPop.stMarketName || resultPop?.marketName}</h1>
                                        <button _ngcontent-tpi-c33="" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                                    </div>
                                    <div _ngcontent-tpi-c33="" class="modal-body">
                                        {
                                            resultPop?.eventTypeName !== 'Fancy' ? (
                                                <div className='my-3'>
                                                    <select onChange={onResultSelectChange} name="winerId" id="">
                                                        <option value="0" disabled selected>Select winner from below</option>
                                                        {
                                                            JSON.parse(resultPop?.runners ? resultPop?.runners : '[]')?.map((x) => (
                                                                <option value={x.selectionId}>{x.runnerName}</option>
                                                            ))
                                                        }
                                                        <option value="Delete">Delete</option>
                                                    </select>
                                                    {/* <input type="number" onChange={onResultDChange} value={resultData.winerId} name='winerId' /> */}
                                                </div>
                                            ) : <div>
                                                <input type="number" onChange={onResultDChange} value={resultData.winerId} name='winerId' />
                                            </div>
                                        }
                                        <button onClick={() => {
                                            dispatch(loaderStart())
                                            resultPop?.eventTypeName !== 'Fancy' ? saveResultToNormal(resultPop.stMarketID || resultPop.marketId, resultData.winerId, resultPop.marketName) :
                                                saveResult(resultPop.stMarketID || resultPop.marketId, resultData.winerId, resultPop.stMarketName || resultPop.marketName).then((data) => {
                                                    if (data?.success) {
                                                        toast.success("Result has been uploaded successfully")
                                                    } else {
                                                        toast.error("Server error")
                                                    }
                                                })
                                            dispatch(loaderStop())
                                        }} data-bs-dismiss="modal" className='btn btn-danger'>Close</button>
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
